// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uvrc","content":"styles_content__1UmUp"};